import Swal from "sweetalert2"
import { swalOption } from "../components/swal-opt.js"
import { htmlDecode } from "./html-decode"

export function handleError(error?: any, confirm?:any) {
	const msg = htmlDecode(error || window.myvars.serverError)
	Swal.fire(swalOption(msg, true, true, undefined, undefined, 'alert-container-class')).then((result) => {
		if (result.value) {
			confirm && confirm()
		}
	})
}

export default handleError
